import React from 'react';
import PropTypes from 'prop-types';

const Pagination = ({ currentPage, totalPages, onNavigate }) => (
  <div className="pagination">
    <button
      className="pagination__link"
      aria-label="Previous page"
      onClick={() => {
        onNavigate(currentPage - 1);
      }}
      disabled={currentPage === 1}
    >
      <svg viewBox="0 0 44 50" className="pagination__link-arrow">
        <use xlinkHref="#pagination-arrow" />
      </svg>
      <svg viewBox="0 0 44 50" className="pagination__link-bg">
        <use xlinkHref="#pagination-arrow-bg" />
      </svg>
    </button>
    <span className="pagination__label">
      {currentPage} of {totalPages}
    </span>
    <button
      className="pagination__link"
      aria-label="Next page"
      onClick={() => {
        onNavigate(currentPage + 1);
      }}
      disabled={currentPage === totalPages}
    >
      <svg viewBox="0 0 44 50" className="pagination__link-arrow">
        <use xlinkHref="#pagination-arrow" />
      </svg>
      <svg viewBox="0 0 44 50" className="pagination__link-bg">
        <use xlinkHref="#pagination-arrow-bg" />
      </svg>
    </button>
  </div>
);

Pagination.propTypes = {
  currentPage: PropTypes.number.isRequired,
  totalPages: PropTypes.number.isRequired,
  onNavigate: PropTypes.func.isRequired
};

export default Pagination;
